import Util from "../../global/util";
import OPNDao, { OPNDaoConfig } from "../opn-snapshot/opn-snapshot.dao";
import { GpnStockForecast, Inventory, OPNParameters } from "../opn-snapshot/opn-snapshot.interface";
import { GPNMatch } from "./gpn-snapshot.interface";

export default class GPNDao {
    public static tiHost: string = '';
    public static inventoryApiUrl: string = '/productmodel/gpn/{gpn}/tistoresegmented';
    public static forecastApiUrl: string = '/ticominventory/api/gpn/{gpn}/futureInventory';
    public static currencyExchangeRateUrl: string = '/productmodel/{gpn}/currencyExchangeRate';
    public static searchApiUrl: string = '/search/gpn';

    public static async searchGPNMatch(searchTerm: string, locale: string, searchApiUrl?: string, tiHost?: string): Promise<GPNMatch> {
        GPNDao.tiHost = tiHost ? tiHost : '';
        GPNDao.searchApiUrl = searchApiUrl ? searchApiUrl : GPNDao.searchApiUrl;
        const match: GPNMatch = await GPNDao.fetchGPNMatch(searchTerm, locale);
        return match;
    }

    public static async fetchGPNMatch(searchTerm: string, locale: string): Promise<GPNMatch> {
        searchTerm = searchTerm.trim().toUpperCase();
        const url = `${GPNDao.tiHost}${GPNDao.searchApiUrl}?searchTerm=${searchTerm}&locale=${locale}`;
        const response = await fetch(url);
        if (!response.ok) {
            return null;
        }
        const json = await response.json();
        if (!json || !json.gpn) {
            return null;
        }

        const match: GPNMatch = json as GPNMatch;
        match.familyUrl = match.familyUrl ? match.familyUrl.replace('overview.html', 'products.html') : '';
        return match;
    }

    public static async fetchOPNDetails(gpn: string, opnList: string[], locale: string): Promise<Array<OPNParameters>> {
        const opnConfig: OPNDaoConfig = new OPNDaoConfig();
        opnConfig.tiHost = GPNDao.tiHost || opnConfig.tiHost;
        const gpnInventory: Map<String, Inventory> = await GPNDao.fetchGPNInventory(gpn);
        const gpnInventoryForecast: GpnStockForecast = await GPNDao.fetchGPNInventoryForecast(gpn, locale);
        const opnParameterPromises = [] as Array<Promise<OPNParameters>>;
        opnList.map(opn => {
            opnParameterPromises.push(OPNDao.fetchOPNParameters(opn, gpn, locale, opnConfig));
        })
        const opnDetails: Array<OPNParameters> = [] as Array<OPNParameters>;
        await Promise.all(opnParameterPromises).then(opnParameters => {
            opnParameters.map(opn => {
                if (opn) {
                    // opn inventory
                    OPNDao.setOPNInventory(gpnInventory, opn);
                    // opn forecast
                    const opnInventoryForecast = OPNDao.getOPNInventoryForecast(gpnInventoryForecast, opn.orderablePartNumber);
                    opn.inventoryForecast = opnInventoryForecast && opnInventoryForecast.forecast ? opnInventoryForecast.forecast : null;
                    opnDetails.push(opn);
                }
            })
        });
        return opnDetails;
    }

    public static async fetchGPNInventoryForecast(gpn: string, locale: string): Promise<GpnStockForecast> {
        const url = Util.formatUrl(`${this.tiHost}${this.forecastApiUrl}?locale=${locale}`, { gpn: gpn });
        const response = await fetch(url);
        if (!response.ok) {
            return {} as GpnStockForecast;
        }
        const json = await response.json();
        const forecast: GpnStockForecast = json as GpnStockForecast;
        return forecast;
    }

    public static async fetchGPNInventory(gpn: string): Promise<Map<String, Inventory>> {
        const url = Util.formatUrl(`${this.tiHost}${this.inventoryApiUrl}`, { gpn: gpn });
        const response = await fetch(url);
        if (!response.ok) {
            if (response.status == 401) {
                return null;
            } else {
                return new Map<String, Inventory>();
            }
        }
        const json = await response.json();
        const inventory: Map<String, Inventory> = json as Map<String, Inventory>;
        return inventory;
    }

    public static async fetchCurrencyExchangeRate(gpn: string, locale: string): Promise<{ [currency: string]: number }> {
        const url = Util.formatUrl(`${this.tiHost}${this.currencyExchangeRateUrl}?locale=${locale}`, { gpn: gpn });
        const response = await fetch(url);
        if (!response.ok) {
            return null;
        }
        const json = await response.json();
        return json;
    }
}
